module.exports = __webpack_public_path__ + "public/images/generated-psychology.1fa82768bcb8100a34bf78415ba14259.jpg";